<template>
    <v-tabs
        v-model="model"
    >
        <v-tab
            v-for="(item, index) in items"
            v-show="item.visible !== false"
            :key="index"
            :disabled="item.disabled"
        >
            {{ item.label }}
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    name: 'TabsNav',
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        items: {
            type: Array,
            required: true
        },
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
</script>